/**
 * Legacy EventApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.eventApi`) keep resolving.
 *
 * The actual EventApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/event/event-api.service.ts
 *
 * NOTE: the `eventApi/types.ts` file (consumed by the facade interface in
 * `apps/b2b-ui/common/services/api/types/index.ts`) is intentionally left
 * untouched — it holds pure type declarations with no AngularJS coupling.
 */
angular.module("acme.common.service.eventApi", [
  "acme.common.service.calendar",
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
